import { FilterItem } from "../Filter/Filter.types";

export interface Header {
  label: string;
  accessor: string;
  type: CellTypes;
  sort?: SortValues;
  searchable?: boolean;
  sortable?: boolean;
  collapsible?: boolean;
  maxWidth?: number;
  minWidth?: number;
  textAlign?: string;
  mediaUrlPrefix?: string;
  sort_accessor?: string;
  maxCount?: number;
}

export enum Status {
  archived = "archived",
  active = "active",
  inactive = "inactive",
  completed = "completed",
  warning = "warning",
  sent_manually = "sent_manually",
  manually_reviewed = "manually_reviewed",
  manually_updated = "manually_updated",
  lets_meet = "lets_meet",
}

export enum CellTypes {
  string = "string",
  numeric = "numeric",
  date = "date",
  image = "image",
  hex = "hex",
  code = "code",
  array = "array",
  element = "element",
  status = "status",
  progress = "progress",
}

export enum SortValues {
  clear = 0,
  asc = 1,
  desc = 2,
}

export interface RowObject {
  [index: string]: any;
}

export enum TableThemes {
  normal = "normal",
  embedded = "embedded",
  minimal = "minimal",
}

export interface TableProps {
  headers: Array<Header>;
  rows: Array<Object> | undefined;
  filters?: Array<FilterItem>;
  rowClick?: (value: Object) => void;
  pageSize?: number;
  navigate?: (value: Object) => void;
  edit?: (value: Object) => void;
  del?: (value: Object) => void;
  add?: () => void;
  addText?: string;
  noModifyProp?: string; // prop such as eternal_id that blocks editing/deleting/etc
  noModifyMessage?: string;
  stickyHeader?: boolean;
  theme?: TableThemes;
  searchText?: string;
  setRowCount?: (value: number) => void;
}
